import { API } from '#app/lib/api/api'
import preq from '#app/lib/preq'
import type { EntityDraft } from '#app/types/entity'
import { getEntityByUri, serializeEntity } from './entities'

export type EntityDraftWithCreationParams = EntityDraft & { createOnWikidata?: boolean }

export async function createEntity (params: EntityDraftWithCreationParams) {
  const { labels, claims, createOnWikidata } = params
  const prefix = createOnWikidata === true ? 'wd' : 'inv'
  const entity = await preq.post(API.entities.create, { prefix, labels, claims })
  if (entity.type === 'edition') {
    // Make server/controllers/entities/lib/get_entities_by_isbns.ts enrich the newly created entity
    return getEntityByUri({ uri: entity.uri, refresh: true, autocreate: true })
  } else {
    return serializeEntity(entity)
  }
}
